import { createSelector } from '@reduxjs/toolkit';
import { CommanderMonitoringFilterLogicalObject } from '../api/util/filter/filter.model';
import { STTimeLineChartData } from '../api/monitoring-ui.model';
import {
  getAllDevicesIdsByMode,
  getDeviceIdFromQueryParam,
} from '../../commander/selectors';
import { RootState } from '../../store.model';

interface OptionsNavProps {
  controlUnitId?: string;
  groupId?: string;
  deviceId?: string;
}
export interface FilterStoredProps extends OptionsNavProps {
  type: 'events' | 'channels';
}
export const getPatchFilter = (props: FilterStoredProps) => {
  const {
    controlUnitId = 'NO_CONTROL_UNIT',
    deviceId = 'NO_DEVICE',
    groupId = 'NO_GROUP',
    type,
  } = props;

  return `HistoryFilter-${type}-${groupId}-${deviceId}-${controlUnitId}`;
};
export const getFilterStored = (state: RootState, props: FilterStoredProps) => {
  const path = getPatchFilter(props) as keyof RootState['featureToggle'];
  const filter = state.featureToggle[path];
  return typeof filter === 'string'
    ? (JSON.parse(filter) as CommanderMonitoringFilterLogicalObject)
    : undefined;
};
